import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Avatar } from '@material-ui/core';
import './Users.scss';

class Users extends Component {
  viewProfile(user) {
    const { history } = this.props;
    try {
      history.push(`/profile/${user.uid}/shoutouts`);
    } catch (error) {
      console.log(error);
    }
  }

  renderUsers() {
    const { users } = this.props;
    return users.map((user) => {
      const fontSize = user.displayName.length > 16 ? 22 : 30;
      const { displayName, title, photoURL, uid } = user;
      return (
        <div className="user-row" key={uid} onClick={()=> this.viewProfile(user)}>
          <Avatar style={{ height: 142, width: 142, marginBottom: 20 }} alt="photoURL" src={photoURL} />
          <span style={{ fontSize, fontWeight: 500 }}>
            {displayName}
          </span>
          <span style={{ fontSize: 14, fontWeight: 500, textTransform: "uppercase" }}>
            {title || "Interapt Employee"}
          </span>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="card-holder">
        {this.renderUsers()}
      </div>
    );
  }

}


const mapStateToProps = ({ usersStore }) => {
  const { users, usersLoading, userProfile } = usersStore;
  const sortedUsers = users.sort((a, b) => a.name.localeCompare(b.name));
  const filteredUsers = sortedUsers.filter((user) => !user.deactivated);
  return { users: filteredUsers, usersLoading, userProfile };
};

export default connect(mapStateToProps)(Users);



// WEBPACK FOOTER //
// ./src/screens/users/Users.js